module.exports = __webpack_public_path__ + "img/house.4bbd7d8a.svg";